import { apiSlice } from './apiSlice';
import { INSURANCES_URL } from '../constants';

export const insurancesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new insurance
    createInsurance: builder.mutation({
      query: (insurance) => ({
        url: INSURANCES_URL,
        method: 'POST',
        body: insurance,
      }),
    }),
    // Get insurance details by ID
    getInsuranceDetails: builder.query({
      query: (id) => ({
        url: `${INSURANCES_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get logged-in user's insurances
    getMyInsurances: builder.query({
      query: () => ({
        url: `${INSURANCES_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get all insurances (Admin view)
    getInsurances: builder.query({
      query: () => ({
        url: INSURANCES_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    // Mark a insurance as delivered (Admin action)
    deliverInsurance: builder.mutation({
      query: (insuranceId) => ({
        url: `${INSURANCES_URL}/${insuranceId}/deliver`,
        method: 'PUT',
      }),
    }),
    // Delete a insurance (Admin action)
    deleteInsurance: builder.mutation({
      query: (insuranceId) => ({
        url: `${INSURANCES_URL}/${insuranceId}`,
        method: 'DELETE',
      }),
    }),
    // Update a insurance
    updateInsurance: builder.mutation({
      query: ({ insuranceId, updatedInsurance }) => ({
        url: `${INSURANCES_URL}/${insuranceId}`,
        method: 'PUT',
        body: updatedInsurance,
      }),
    }),
  }),
});

export const {
  useCreateInsuranceMutation,
  useGetInsuranceDetailsQuery,
  useGetMyInsurancesQuery,
  useGetInsurancesQuery,
  useDeliverInsuranceMutation,
  useDeleteInsuranceMutation,
  useUpdateInsuranceMutation, // Newly added export
} = insurancesApiSlice;